exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Stack___2ZEoS > *:not(:first-child) {\n  border-top: 1px solid var(--color-border);\n}\n", ""]);

// exports
exports.locals = {
	"Stack": "Stack___2ZEoS"
};